import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { postData } from 'src/utils/axios/serverHelper';

interface ProgramLogRequest {
	programId: string;   // menuCd (?: MST4010_R01)
	actionType?: string; // ??? 'OPEN'
	deviceType?: string; // ??? 'MES'
}

/**
 * ???? ?? ?? ??
 * - ???? ?? ??? ?? ?? (fire-and-forget)
 */
export const postProgramLog = async (request: ProgramLogRequest): Promise<void> => {
	try {
		await postData<ProgramLogRequest, ResponseDto<void>>(
			`${config.apiUrl}/program-log`,
			{
				programId: request.programId,
				actionType: request.actionType ?? 'OPEN',
				deviceType: request.deviceType ?? 'MES',
			}
		);
	} catch (e) {
		// ?? ??? UX? ?? ?? ? ? ? ??? ??
		console.warn('[ProgramLog] ?? ?? (??):', e);
	}
};
